import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const SpinnerComponent = ({ fontSize }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: fontSize || 24 }} spin />;
  return <Spin indicator={antIcon} />;
};

export default SpinnerComponent;
